import { render } from "./UserWithdrawals.vue?vue&type=template&id=1d4883a7&scoped=true&ts=true"
import script from "./UserWithdrawals.vue?vue&type=script&lang=ts"
export * from "./UserWithdrawals.vue?vue&type=script&lang=ts"

import "./UserWithdrawals.vue?vue&type=style&index=0&id=1d4883a7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d4883a7"]])

export default __exports__